import { component } from 'picoapp';

export default component(async (node) => {
  node.addEventListener('click', () => {
    navigator.clipboard.writeText(window.location.href);
  });
});
